import { addCtiLogEntry } from 'flow/utils/browser-utils';
import { fetchCallRecordWithEntityKey } from 'flow/actions/extension-actions';
import { selectLoggedInCustomer } from 'flow/selectors/customer-selectors';

export const fetchCallRecord = (locutusSessionId) => async (dispatch) => {
    // Fetch the call record of the session. On result it will update the store which enables
    // us to read the call record from there.
    try {
        return await fetchCallRecordWithEntityKey(`call-${locutusSessionId}`, [
            'contact',
            'apps',
            'recordings',
        ])(dispatch);
    } catch (error) {
        addCtiLogEntry(
            `Failed to fetch call record for entity key call-${locutusSessionId}: ${error}`,
        );
        throw error;
    }
};

//use to debug error report INTE-2209, remove it when the problem is solved
export const ctiTraceLog = (state, msg, locutusSessionId) => {
    const customer = selectLoggedInCustomer(state);
    if (customer != undefined) {
        if (customer.get('key') === 'customer-258837') {
            addCtiLogEntry(
                `customer: ${customer.get(
                    'key',
                )} locutusSessionId: ${locutusSessionId} `,
                msg,
            );
        }
    }
};
